/**
 * ReportsHarvestInspectionsTableRow
 */
import React from 'react';
import { Table } from 'semantic-ui-react';

// Components
import ReportsHarvestInspectionAverageSize from '../../../../../../components/ReportsHarvestInspectionAverageSize';
import ReportsHarvestInspectionCosmeticDefectPercentage from '../../../../../../components/ReportsHarvestInspectionCosmeticDefectPercentage';
import ReportsHarvestInspectionEntityName from '../../../../../../components/ReportsHarvestInspectionEntityName';
import ReportsHarvestInspectionJobState from '../../../../../../components/ReportsHarvestInspectionJobState';
import ReportsHarvestInspectionNumberOfContainers from '../../../../../../components/ReportsHarvestInspectionNumberOfContainers';
import ReportsHarvestInspectionNumberOfInspections from '../../../../../../components/ReportsHarvestInspectionNumberOfInspections';
import ReportsHarvestInspectionOverallDefectPercentage from '../../../../../../components/ReportsHarvestInspectionOverallDefectPercentage';
import ReportsHarvestInspectionParentEntityName from '../../../../../../components/ReportsHarvestInspectionParentEntityName';
import ReportsHarvestInspectionPestDefectPercentage from '../../../../../../components/ReportsHarvestInspectionPestDefectPercentage';
import ReportsHarvestInspectionPickerFaultPercentage from '../../../../../../components/ReportsHarvestInspectionPickerFaultPercentage';
import ReportsHarvestInspectionPickTypeName from '../../../../../../components/ReportsHarvestInspectionPickTypeName';
import ReportsHarvestInspectionSpoiltDefectPercentage from '../../../../../../components/ReportsHarvestInspectionSpoiltDefectPercentage';
import ReportsHarvestInspectionVarietyName from '../../../../../../components/ReportsHarvestInspectionVarietyName';
import ReportsHarvestInspectionsTableRowLink from './components/ReportsHarvestInspectionsTableRowLink';

interface Props {
    eventId?: number;
    jobType?: string;
}

export default class ReportsHarvestInspectionsTableRow extends React.PureComponent<Props> {
    static defaultProps = {
        eventId: null
    };

    render() {
        const { eventId, jobType } = this.props;
        if (!eventId) return null;

        return (
            <ReportsHarvestInspectionsTableRowLink
                eventId={eventId}
                jobType={jobType}
            >
                <Table.Cell>
                    <ReportsHarvestInspectionParentEntityName
                        eventId={eventId}
                    />
                </Table.Cell>
                <Table.Cell>
                    <ReportsHarvestInspectionEntityName eventId={eventId} />
                </Table.Cell>
                <Table.Cell>
                    <ReportsHarvestInspectionVarietyName eventId={eventId} />
                </Table.Cell>
                <Table.Cell>
                    <ReportsHarvestInspectionPickTypeName eventId={eventId} />
                </Table.Cell>
                {jobType === 'INSPECTION' && (
                    <React.Fragment>
                        <Table.Cell>
                            <ReportsHarvestInspectionNumberOfInspections
                                eventId={eventId}
                            />
                        </Table.Cell>
                        <Table.Cell>
                            <ReportsHarvestInspectionAverageSize
                                eventId={eventId}
                            />
                        </Table.Cell>
                        <Table.Cell>
                            <ReportsHarvestInspectionCosmeticDefectPercentage
                                eventId={eventId}
                            />
                        </Table.Cell>
                        <Table.Cell>
                            <ReportsHarvestInspectionPestDefectPercentage
                                eventId={eventId}
                            />
                        </Table.Cell>
                        <Table.Cell>
                            <ReportsHarvestInspectionPickerFaultPercentage
                                eventId={eventId}
                            />
                        </Table.Cell>
                        <Table.Cell>
                            <ReportsHarvestInspectionSpoiltDefectPercentage
                                eventId={eventId}
                            />
                        </Table.Cell>
                        <Table.Cell>
                            <ReportsHarvestInspectionOverallDefectPercentage
                                eventId={eventId}
                            />
                        </Table.Cell>
                    </React.Fragment>
                )}
                {jobType === 'TIMESHEET' && (
                    <Table.Cell>
                        <ReportsHarvestInspectionNumberOfContainers
                            eventId={eventId}
                        />
                    </Table.Cell>
                )}

                <Table.Cell textAlign="right">
                    <ReportsHarvestInspectionJobState
                        eventId={eventId}
                        jobType={jobType}
                    />
                </Table.Cell>
            </ReportsHarvestInspectionsTableRowLink>
        );
    }
}
